import { defineStore } from 'pinia'
import { TOURS_CODES } from '~/constants'
import useAuthStore from '~/store/auth'

type SnackTypes = 'info' | 'error' | 'success'

type DynamicComponent = {
  value: boolean
  component: Component | undefined
  data: Object
  events: Object
}

interface State {
  snackBanners: {
    type: SnackTypes
    text: string
    id: number
  }[]
  dynamicPopup: DynamicComponent
  dynamicMobilePanel: DynamicComponent
  mobileHeaderFixed: boolean
}

const initDynamicComponent = () => ({
  value: false,
  component: undefined,
  data: {},
  events: {},
})

const initialSnackBanner = [] as State['snackBanners']

const useUIStore = defineStore('ui', {
  state: (): State => ({
    snackBanners: [...initialSnackBanner],
    dynamicPopup: initDynamicComponent(),
    dynamicMobilePanel: initDynamicComponent(),
    mobileHeaderFixed: true,
  }),
  actions: {
    showSnackBanner(text: string = '', type: SnackTypes = 'success') {
      this.snackBanners.push({
        id: Date.now(),
        type,
        text: text || (type === 'success' ? 'Success' : 'Something went wrong'),
      })
    },
    showPopup(component: Component, data: Object = {}, events: Object = {}) {
      this.dynamicPopup = {
        value: true,
        component: markRaw(component),
        data,
        events,
      }
    },
    cleanPopup() {
      this.dynamicPopup = initDynamicComponent()
    },
    showMobilePanel(component: Component, data: Object = {}, events: Object = {}) {
      this.dynamicMobilePanel = {
        value: true,
        component: markRaw(component),
        data,
        events,
      }
    },
    cleanMobilePanel() {
      this.dynamicMobilePanel = initDynamicComponent()
    },
    fixMobileHeader() {
      this.mobileHeaderFixed = true
    },
    unfixMobileHeader() {
      this.mobileHeaderFixed = false
    },
    resetSnackBanner(id: State['snackBanners'][number]['id']) {
      this.snackBanners = this.snackBanners.filter(item => item.id !== id)
    },
    getIsTourCompleted(code: TOURS_CODES) {
      const { getTours } = useAuthStore()

      return Boolean(getTours().includes(code))
    },
  },
  getters: {
    getDynamicPopup: ({ dynamicPopup }) => dynamicPopup,
    getDynamicMobilePanel: ({ dynamicMobilePanel }) => dynamicMobilePanel,
  },
})

export default useUIStore
